import React from "react";
import { Reoverlay } from "reoverlay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSun,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import "./SummerPopup.css";

const SummerPopup = ({ title, description, fromDate, toDate, backOpen }) => {
  const handleClose = () => {
    Reoverlay.hideModal();
  };

  return (
    <div className="summer-popup" onClick={handleClose}>
      <div className="popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close-button" onClick={handleClose} aria-label="Sluiten">
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2 className="popup-title">
          <FontAwesomeIcon icon={faSun} /> {title || "Wij gaan er even tussenuit!"}
        </h2>
        <p className="popup-description">
          {description ||
            `Van ${fromDate || "20 juli"} tot en met ${
              toDate || "7 augustus"
            } zijn wij gesloten wegens verlof. Vanaf ${
              backOpen || "10 augustus"
            } staan wij weer voor u klaar!`}
        </p>
        <button className="popup-ok-button" onClick={handleClose}>
          Sluiten
        </button>
      </div>
    </div>
  );
};

export default SummerPopup;